import { create } from 'zustand';

// CAUTION: This is only temporary and may fail in the future if Safari changes their private mode behavior
export const useGenStore = create(() => ({
  isSafariPrivate: false,
}));
